var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('video',{ref:"myref",attrs:{"src":"https://ubiquity.tv/backend/media/pages/directors/audrey-mascina/lancome-idoles/2702929876-1599891895/2.-lancome-idoles-audrey-mascina.mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }